
 
 <div class="center">
   <div class="arrowTabs" style="width : 100% !important;">
         <a class="finished"  style="cursor: default !important;">Step 1: Select Training Method</a>
         <a class="active"  style="cursor: default !important;">Step 2 : Upload Supporting Files</a>
         <a  style="cursor: default !important;">Step 3 : Pre-process and Train the System</a>
     </div>
  </div>
  <br /><br />
  
  <div class="col-lg-12">
    
    <div class="card" style="width:100%;">
    
      <p class="alert alert-danger" id="successMessage" *ngIf = "result.Error != null">
        <i class="fa fa-exclamation-triangle" aria-hidden="true" ></i>
          {{result.Error}}
          <a (click)="redirect()" style = " color:#666">
            ( Click here to upload Tax Code Mapping File )
          </a>
      </p>

      
      <br />
      <h3 class="heading3" style="text-align:center;">Upload New Excel Files, if any</h3>
      
      <div class="center">
        <form enctype="multipart/form-data" 
          class="dropzone" id="dropzoneForm" style="width:auto;margin:0 40px;position:relative;min-height:280px;height:auto;"
          [dropzone]="config" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
          <div class="dz-default dz-message">
            <img src="./assets/static/upload.png">
            <br>
            <br>
            <span style="color:#808080 !important;">
              <b>Drag and Drop excel files here or click to browse for files</b>              
            </span>
          </div>
          <div class="fallback">
          
            <!-- <input type="file" (change)="fileChange($event)" multiple id="btnUpload" value="Upload" class="upload" />
            <br>
            <input type="submit" value="Upload"> -->
          </div>
        </form>
      </div>
    
      <br><br />
      <form (submit)="preprocessExisting()" *ngIf="click">
      
        <div class="center">
          <button id="preprocess" type="submit" class="btn btn-lg btn-primary buttonStyle">Pre-Process</button>
        </div>
      
      <br /><br /><br />
      </form>
    
      <div class="center" *ngIf="!click" >
      
        <div class="row" style="margin-right: 25%; margin-left: 25%;">
          <div class="col-xs-11">
            <div id="progress" class="progress" style="width:100%;height:37px;margin-top:30px;">
        
              <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" 
                aria-valuemin="0" aria-valuemax="100" style="width:100%;">
        
              </div>
            </div>
          </div>
          <div class="col-xs-1" style="height:37px;margin-top:30px;padding-left: 0px;margin-left: 0px;margin-bottom: 20px;">
            <a class="btnDel" style="cursor:pointer;" (click)="CancelTrain()">
              <i class="fa fa-close" style="font-size:36px;color:red"></i>
            </a>
          </div>
        </div>
      
        <h5 id="text" style="color:rgba(128, 128, 128, 0.92)">The process could take a while. Please do not reload this page or navigate to another page.</h5>
      
        <!-- <div id="t" class="badge">00:00</div> -->
      </div>
    
      <br />
      <div class="center">
                
        <button type="button" *ngIf="enableGetLogs" (click)="OpenLogsDialog()" class="btn btn-lg btn-primary buttonStyle" 
            style="margin:30px 60px 30px 60px !important;"  >
            Get Logs
        </button>
    
    </div>
    </div>
  </div>